module.exports = __webpack_public_path__ + "static/media/c12_7.076a9a9c.png";